var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.custom.loading,"empty":_setup.custom.empty}},[_c(_setup.BreifCard,{attrs:{"listData":_setup.listData,"styleConfig":_vm.styleConfig},on:{"goToDetail":_setup.goDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }